import React from 'react';
import HelpIcon from 'images/help.svg';

const Card = (props) => {
  const { title, text, action, image } = props;

  return (
    <div className='card'>
      <div className='card-body'>
        <div className='text-center'>
          <img alt='Back' src={image} />
          <h5>{title}</h5>
          <p>{text}</p>
          <a className="btn btn-primary" role="button" href={action.href}>{action.name}</a>
        </div>
      </div>
      <hr className="invisible" />
    </div>
  );
};

const HelpCard = (props) => {
  const { title, text, action } = props;

  return (
    <div className='side-style yellow card'>
      <div className='card-body'>
        <div className='text-center'>
          <img alt='Back' src={HelpIcon} width="25" />

          <div className="text-left">
            <h5>{title}</h5>
            <p>{text}</p>
            <a className="btn btn-outline-primary" role="button" href={action.href}>{action.name}</a>
          </div>
        </div>
      </div>
      <hr className="invisible" />
    </div>
  );
};

export { Card, HelpCard };
